import React from 'react';
import { Box } from '@mui/material';
import seaview from '../files/images/dos.avif';

export default function Background() {
  return (
    <Box
      component="img"
      src={seaview}
      alt="seaview"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        zIndex: -1,
        objectFit: 'cover',
        objectPosition: 'center',
      }}
    />
  );
}
